module.exports = __webpack_public_path__ + "img/islington_b2.f74a77f1.jpg";